export const appointmentTypeLabelColors: string[] = [
  '#DD3131',
  '#FF837A',
  '#B245D1',
  '#D88EEC',
  '#146EF5',
  '#6BA6FF',
  '#018479',
  '#22CBC1',
  '#C0873A',
  '#F2BE04',
];

export const defaultAppointmentTypeLabelColor = '#146EF5';
